import { Tooltip } from '@chakra-ui/react';
import type { PropsWithChildren, ReactNode } from 'react';

import tooltipStyles from '../../utilities/chart-tooltip.module.css';

type PieTooltipProps = PropsWithChildren & {
  label: ReactNode;
};

export const PieTooltip = ({ label, children }: PieTooltipProps) => {
  return (
    <Tooltip
      hasArrow
      label={label}
      padding="8px 12px"
      placement="top"
      borderRadius="4px"
      data-testid="pie-tooltip"
      className={tooltipStyles.surface}
    >
      {children}
    </Tooltip>
  );
};
